module.exports = __webpack_public_path__ + "static/img/Application_Interaction_Example3.7ffa6cf3.png";